export default {
  'Sample photo': 'Образец фото',
  Removing: 'Удаление',
  Edit: 'Редактировать',
  'Adjust Picture': 'Настройка изображения',
  Restore: 'Восстановить',
  Eraser: 'Ластик',
  Size: 'Размер',
  Background: 'Задний план',
  Custom: 'Стандарт',
  Presets: 'Предустановка',
  'Add Image': 'Добавить изображение',
  'Scale to Fit': 'Масштабироваться в соответствии',
  'Full Width': 'Полная ширина',
  'Full Height': 'Полная высота',
  Move: 'Двигать',
  Undo: 'Отменить',
  Redo: 'Повторить',
  Enlarge: 'Увеличить',
  Reduce: 'Уменьшать',
  //2022.09.28 xxy
  BGRemover: {
    title: 'HitPaw Online для удаления фона',
    desc: 'Легко удаляйте фон ваших фотографий на 100% автоматически и бесплатно',
    imgAlt: 'photo background remover',
    submitBtn: 'Удалить фон',
  },
  BGChanger: {
    title: 'HitPaw Photo Background Changer',
    desc: 'Extremely easy to change photo background 100% automatically & free',
    imgAlt: 'photo background change',
    submitBtn: 'Change Background',
  },
  "Shadows" : "Shadow",
  "Intensity" : "Opacity",
  "Radius" : "Radius",
  "Color" : "Color",
  "Move" : "Move Shadow",
  "2D move" : "2D",
  "3D move" : "3D",
  "Move the shadow" : "Drag the shadow around in the image",
      "Upload failed, click to try again": "Upload failed, click to try again",
};
